import AxiosInstance from 'utils/AxiosInstance'
import {
  FETCH_NOTIFICATIONS,
  INCREASE_LIMIT,
  REMOVE_COURSE_FROM_NAVBAR_NOTIFICATIONS,
  SET_FILTERED_TYPES,
  SET_NAVBAR_NOTIFICATIONS,
  SET_TOTAL_NOTIFICATIONS,
  TOGGLE_READ_FILTER,
  TOGGLE_UNREAD_FILTER,
} from './constants'

export const setNavbarNotifications = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/alerts?limit=6').then((data) => {
      console.log('🚨 frontend received alerts:', data)
      dispatch({ type: SET_NAVBAR_NOTIFICATIONS, payload: data?.alerts })
    })
  }
}

export const fetchNotifications = () => {
  return (dispatch, getState) => {
    const { limit } = getState().notification

    AxiosInstance.get(`/alerts?limit=${limit}`).then((data) => {
      dispatch({ type: FETCH_NOTIFICATIONS, payload: data?.alerts })
      dispatch({ type: SET_TOTAL_NOTIFICATIONS, payload: data?.total_alerts })
    })
  }
}
export const removeNotifications = (alertIds, all = false) => {
  return (dispatch, getState) => {
    const url = all
      ? `/alerts?all=true`
      : `/alerts?alertIds=${alertIds.join(',')}`

    AxiosInstance.delete(url)
      .then(() => {
        dispatch(fetchNotifications())
        dispatch(setNavbarNotifications())
      })
      .catch((error) => {
        console.error('Error removing notifications:', error)
      })
  }
}

export const markAsRead = (alertIds, all = false, unread = false) => {
  return (dispatch, getState) => {
    AxiosInstance.put(
      `/alerts${all ? '?all=true' : ''}${unread ? '?unread=true' : ''}`,
      { alertIds }
    ).then(() => {
      dispatch(fetchNotifications())
      dispatch(setNavbarNotifications())
    })
  }
}

export const toggleUnreadFilter = () => ({ type: TOGGLE_UNREAD_FILTER })
export const toggleReadFilter = () => ({ type: TOGGLE_READ_FILTER })

export const increaseLimit = () => ({ type: INCREASE_LIMIT })

export const setFilteredTypes = (types) => ({
  type: SET_FILTERED_TYPES,
  payload: types,
})

// export const updateNotificationReadStatus = (notificationId) => {
//     return (dispatch, getState) => {
//         AxiosInstance.put(`/notifications/${notificationId}`).then(() => {
//             dispatch(setNavbarNotifications())
//         })
//     }
// }

export const removeCourseFromNavbarNotifications = (deletedId) => ({
  type: REMOVE_COURSE_FROM_NAVBAR_NOTIFICATIONS,
  payload: deletedId,
})
